import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/messaging";
import "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyD9pH7z6fTTnKbosqLke8qglrWb-L9pcw8",
  authDomain: "chatdeck-04.firebaseapp.com",
  projectId: "chatdeck-04",
  storageBucket: "chatdeck-04.appspot.com",
  messagingSenderId: "415023991903",
  appId: "1:415023991903:web:8f98444c3af45e7f011fea",
  measurementId: "G-T8LNVHKGHT",
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();
export default firebase;
